import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';
import {haveSameFields} from "../../utils/utils";

const initialState = {
    token: null,
    accountId: null,
    userId: null,
    error: null,
    loading: false,
    authLevel: 0,
    userPermissions: {
        delete_comment: 0,
        delete_patterns :0,
        delete_games: 0,
        edit_patterns: 0,
        give_permissions: 0
    },
    userPreferences: {
        auto_load_game_demos: 0
    },
    notifications: {
        notifications: [],
        fetched_timestamp: '2000-01-01 00:00:00',
        hidden_content: [],
        no_contact_email_content: {}
    },
    authRedirectPath: '/',
    responseMessage: null,
    //loggedIn: null
};

const authStart = ( state, action ) => {
    return updateObject( state, { error: null, loading: true } );
};

const authSuccess = (state, action) => {
    let notif = {...initialState.notifications,  ...action.notifications};

    return updateObject( state, { 
        token: action.idToken,
        accountId: action.accountId,
        authLevel: action.authLevel,
        userId: action.userId,
        userPermissions: action.user_permissions && haveSameFields(action.user_permissions, initialState.userPermissions) ? action.user_permissions : initialState.userPermissions,
        userPreferences: action.user_preferences && haveSameFields(action.user_preferences, initialState.userPreferences) ? action.user_preferences : initialState.userPreferences,
        notifications: action.notifications && haveSameFields(notif, initialState.notifications) ? notif : initialState.notifications,
        error: null,
        loading: false
     } );
};

const authFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
};

const authLogout = (state, action) => {
    return updateObject(state, { token: null, accountId: null, userId: null, authLevel: null, userPermissions: initialState.userPermissions, userPreferences: initialState.userPreferences, notifications: initialState.notifications });
};

const passwordResetStart = ( state, action ) => {
    return updateObject( state, { responseMessage: null, error: null, loading: true } );
};

const passwordResetSuccess = (state, action) => {
    return updateObject( state, {
        responseMessage: action.responseMessage,
        resetRedirect: false,
        error: null,
        loading: false
    } );
};

const passwordResetFail = (state, action) => {
    return updateObject( state, {
        responseMessage: action.responseMessage,
        resetRedirect: false,
        error: action.error,
        loading: false
    });
};

const setAuthRedirectPath = (state, action) => {
    return updateObject(state, { authRedirectPath: action.path })
};

const editUserSubmit = (state, action) => {
    return updateObject(state, { userId: action.userId })
};

const backToLogin = (state, action) => {
    return updateObject(state, {
        responseMessage: null
    })
}

const updateAutoLoadGame = (state, action) => {
    return updateObject(state, {
        userPreferences: {
            ...state.userPreferences, auto_load_game_demos: action.value
        }
    })
}

const updateNotifications = (state, action) => {
    // console.log({notifications: action.value})
    let notif = {...initialState.notifications, ...state.notifications,  ...action.value}; // makes sure we don't lose timestamp key in object
    localStorage.setItem('notifications', JSON.stringify( notif ));
    return updateObject(state, {
        notifications: notif
    })
}

// const setLoggedInState = (state, action) => {
//     return updateObject(state, { loggedIn: action.loggedIn})
// }

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.PASSWORD_RESET_START: return passwordResetStart(state, action);
        case actionTypes.PASSWORD_RESET_SUCCESS: return passwordResetSuccess(state, action);
        case actionTypes.PASSWORD_RESET_FAIL: return passwordResetFail(state, action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state, action);
        case actionTypes.EDIT_USER_SUBMIT: return editUserSubmit(state, action);
        case actionTypes.BACK_TO_LOGIN: return backToLogin(state, action);
        case actionTypes.UPDATE_AUTO_LOAD_GAME_EMBEDS: return updateAutoLoadGame(state, action);
        case actionTypes.UPDATE_NOTIFICATIONS: return updateNotifications(state, action);
        //case actionTypes.LOGGED_IN_STATE: return setLoggedInState(state, action);
        default:
            return state;
    }
};

export default reducer;